import React from 'react';
import './fonts/font.css';
import './sass/index.scss';
import * as SentryModule from './sentry';
import App from './components/app';
import { createRoot } from 'react-dom/client';

SentryModule.init();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);
